// eslint-disable-next-line no-redeclare,no-unused-vars
function setTitle(value, changeTitleCache) {
  $('#systemInfo').text(value);
  if (changeTitleCache) window.title = value;
  if (localStorage.getItem('mute')) value = '☾ ' + value;
  document.title = value;
}
